import { useSelector } from 'react-redux'

import { calculateSectionScore } from '~/pages/anatomyV2/libs/calculateSectionScore'
import SectionCompleteTemplate from '~/pages/anatomyV2/libs/components/SectionCompleteTemplate'
import { SECTION_4_SCORING } from '~/pages/anatomyV2/libs/scoredSections'
import { selectAnswers } from '~/shared/store/common/selects'
import { TPageProps } from '~/shared/types/commonTypes'

const NEXT_SECTION_NUMBER = 5
const POINTS_GOAL =
  SECTION_4_SCORING.scoredPageIds.length * SECTION_4_SCORING.pointsPerQuestion

const Section4CompleteAnatomyV2 = (props: TPageProps) => {
  const answers = useSelector(selectAnswers)
  const pointsEarned = calculateSectionScore(SECTION_4_SCORING, answers)

  return (
    <SectionCompleteTemplate
      {...props}
      nextSectionNumber={NEXT_SECTION_NUMBER}
      titleI18nKey="onboarding.section4Complete.title"
      subtitleI18nKey="onboarding.section4Complete.subtitle"
      pointsEarned={pointsEarned}
      pointsGoal={POINTS_GOAL}
      question="Section 4 complete"
    />
  )
}

export default Section4CompleteAnatomyV2
